module.exports = __webpack_public_path__ + "1ae277e0edc84aff6b9eb64a8fec4573.pdf";